<template>
	<div class="px-4" :class="type == 'room-dining'? 'mb-4 pb-4 border-b-semi-grey':'py-4 box-shadow-primary rounded-10'">
    <p class="mb-0 body-1-4">{{$t('hotel.concierge.promotion.promo')}}</p>
    <p class="mb-2 body-2-2-1">{{$t('hotel.concierge.promotion.getting-cheaper-with-promo')}}</p>
    <template v-if="promo == null">
    	<template v-if="type == 'room-dining'">
	    	<div class="w-100 border-semi-grey radius-12 py-2 pr-2 mb-1" :class="{'border-danger':promo_error != '' || promo_error_typing != ''}">
	    		<div class="row no-gutters">
	    			<div class="col-9 align-self-center">
	    				<div class="w-100 position-relative">
		    				<input 
									type="text" 
									class="border-none body-2-4 mb-0 no-focus-border pl-5 pr-3 pb-1" 
									:class="isMembershipRewardApplied ? 'cursor-disable': ''"
									placeholder="Input promo code here" 
									:disabled="isMembershipRewardApplied" 
									v-model="promo_code" 
									@blur="promoCodeToUpperCase" 
									@keyup.enter="validatePromoCode" />
		    				<img src="../../../../assets/img/icon/discount-dark.png" height="18" class="position-absolute" style="left:16px;top:4px;">
		    				<i v-if="promo_code != ''" @click="clearForm()" class="simple-icon-close text-18 text-semi-dark position-absolute cursor-pointer" style="right:8px;top:4px;"></i>
		    			</div>
	    			</div>
	    			<div class="col-3 align-self-center">
	    				<button 
	    					class="ga-btn-primary-md disabled"
								:class="isMembershipRewardApplied ? 'button-disabled': ''"
	    					@click="validatePromoCode" 
	    					:disabled="promo_loader || promo_code == '' || promo_error_typing != ''">
	              <pulse-loader :loading="promo_loader" size="12px" color="#fff" v-if="promo_loader"></pulse-loader>
			          <template v-else>
			            {{$t('hotel.concierge.promotion.apply')}}
			          </template>
	            </button>
	    			</div>
	    		</div>
	    	</div>
	    	<p class="mb-3 body-3-3-1 text-danger" v-if="promo_error != ''"><i class="simple-icon-close mr-1"></i>{{promo_error}}</p>
	      <p class="mb-3 body-3-3-1 text-danger" v-if="promo_error_typing != ''"><i class="simple-icon-close mr-1"></i>{{promo_error_typing}}</p>
				<p class="mb-3 body-3-3-1 text-danger" v-if="isMembershipRewardApplied">Cannot apply promo code while claiming reward</p>
	    </template>
	    <div class="row slim-grid-row" v-else>
	      <div class="col-8">
	        <input type="text" class="form-control body-2-2 mb-0 font-bold text-18" :class="{'border-danger':promo_error != '' || promo_error_typing != ''}" placeholder="" style="height: 47px" v-model="promo_code" @blur="promoCodeToUpperCase" />
	        <p class="mb-3 body-3-3-1 text-danger" v-if="promo_error != ''">{{promo_error}}</p>
	        <p class="mb-3 body-3-3-1 text-danger" v-if="promo_error_typing != ''">{{promo_error_typing}}</p>
	      </div>
	      <div class="col-4">
	         <button @click="validatePromoCode" :disabled="promo_loader || promo_code == '' || promo_error_typing != ''" type="button" class="g-btn g-btn-primary w-100 g-btn-md" :class="{'button-disabled': promo_loader || promo_code == '' || promo_error_typing != ''}" style="height: 47px;">
	          <pulse-loader :loading="promo_loader" color="#fff" v-if="promo_loader"></pulse-loader>
	          <template v-else>
	            {{$t('hotel.concierge.promotion.apply')}}
	          </template>
	        </button>
	      </div>
	    </div>
    </template>
    <template v-else>
    	<template v-if="type == 'room-dining'">
    		<div class="radius-12 px-5 py-3 position-relative bg-border-green-light mb-2">
    			<p class="mb-0 body-2-1">{{promo.name}}</p>
          <p class="mb-0 body-3-3-1">{{promo.description}}</p>
    			<img src="../../../../assets/img/icon/discount-dark.png" height="18" class="position-absolute" style="left:16px;top:16px;">
    			<i @click="clearPromoAffected()" class="simple-icon-close text-22 text-semi-light position-absolute cursor-pointer" style="right:16px;top:24px;"></i>
    		</div>
    		<p class="mb-3 body-3-3-1 text-danger" v-if="!is_match_product"><i class="simple-icon-close mr-1"></i> {{$t('hotel.concierge.promotion.product-not-affected')}} "{{promo.name}}".</p>
    	</template>
    	<template v-else>
		    <div class="py-3 px-2 border radius-0 d-block mb-2 position-relative" style="background-color: rgb(243, 255, 244); border-color: rgb(193, 254, 184) !important;">
		      <div class="row no-gutters">
		        <div class="col-2 align-self-center">
		          <div class="bg-green p-2 rounded-100 d-table mx-auto" style="line-height: 0 !important">
		            <!-- <img src="../../../../assets/img/icon/correct-white.png" width="15" class="position-relative"> -->
		            <i class="simple-icon-tag text-22 text-white"></i>
		          </div>
		        </div>
		        <div class="col-10 align-self-center">
		          <div class="mx-2">
		            <p class="mb-0 body-3-3-1 text-10" v-if="is_match_product">{{$t('hotel.concierge.promotion.promotion-applied')}}</p>
		            <p class="mb-0 text-green body-1-4">{{promo.name}}</p>
		            <p class="mb-0 body-2-2">{{promo.description}}</p>
		          </div>
		        </div>
		      </div>
		      <img @click="clearPromoAffected" src="../../../../assets/img/icon/close.png" width="12" class="position-absolute cursor-pointer" style="top:8px;right:8px;">
		    </div>
		    <p v-if="!is_match_product" class="mb-0 body-2-2 text-center text-danger">{{$t('hotel.concierge.promotion.product-not-affected')}} "{{promo.name}}".</p>
		  </template>
	  </template>
  </div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {post,get} from '@/services/index.js';
	export default{
		props: ['type'],
		data(){
			return{
				promo_code: '',
        promo_error: '',
        promo_error_typing: '',
        promo_loader: false,
        promo:null,
        is_match_product: true
			}
		},
		computed:{
			...mapGetters(['getMerchant','getConciergeOrder','isMembershipRewardApplied']),
			product_cart(){
				return this.type == 'spa' ?	this.getConciergeOrder.custom.length : this.getConciergeOrder.cart.length
			}
		},
		watch:{
      promo_code(){
        this.promo_error = ''
        if(this.promo_code.includes(' ')){
          this.promo_error_typing = this.$t('hotel.concierge.promotion.cannot-contain-space')
        } else if(this.promo_code != '' && /^[A-Za-z0-9]+$/.test(this.promo_code) == false){
          this.promo_error_typing = this.$t('hotel.concierge.promotion.only-letters-number')
        } else{
          this.promo_error_typing = ''
        }
      },
      product_cart(){
      	this.is_match_product = this.checkIfProductInPromotion()
      },
      is_match_product(){
      	if(this.is_match_product){
      		this.applyPromoToProduct()
      	}
      },
    },
    mounted(){
    	if(this.getConciergeOrder.promo_code != ''){
    		this.promo_code = this.getConciergeOrder.promo_code
    		this.validatePromoCode()
    	}
    },
    methods:{
    	...mapMutations([
    		'setSpecificConcierOrder',
    		'resetSpecificConciergeOrder',
    		'setConciergeOrderPromoCode',
    		'setSpecificConcierOrderCustom',
    		'resetSpecificConciergeOrderCustom']),
    	clearForm(){
    		this.promo_code = ''
        this.promo_error = ''
        this.promo_loader = false
        this.promo = null
    	},
    	promoCodeToUpperCase(){
        let copy = this.promo_code.toUpperCase()
        this.promo_code = copy
      },
      clearPromoAffected(){
      	this.applyPromoToProduct(false).then(()=>{
      		this.setConciergeOrderPromoCode("")
	        this.clearForm()
      	})
      },
      validatePromoCode(){
        if(!this.promo_loader && this.promo_code != '' && this.promo_error_typing == ''){
          this.promo_loader = true
          this.promo_error = ''
          get("CONCIERGE", this.type+"/promo-code/"+this.promo_code,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.promo = res.data
              this.is_match_product = this.checkIfProductInPromotion()
              if(this.is_match_product){
              	this.setConciergeOrderPromoCode(res.data.promo_code)
              	this.applyPromoToProduct()
              }
            }else{
              this.promo_error = this.$t('hotel.concierge.promotion.not-found')
            }
            this.promo_loader = false
          })
        }
      },
      checkIfProductInPromotion(){
      	let is_promo = false
      	if(this.type == 'room-dining' || this.type == 'extra-amenities'){
      		for(let cart of this.getConciergeOrder.cart){
      			for(let product_promo of this.promo.product_affected_list){
      				if(cart.product.is_variant){
      					for(let cart_variant of cart.variant){
      						if(cart_variant.data.product_ga_pos_id == product_promo.product_ga_pos_id){
      							is_promo = true
	      						break
      						}
      					}
      					if(is_promo){
		      				break
		      			}
      				}else{
	      				if(cart.product.data.product_ga_pos_id == product_promo.product_ga_pos_id){
	      					is_promo = true
	      					break
	      				}
      				}
      			}
      			if(is_promo){
      				break
      			}
      		}
      	}else{
      		for(let cart of this.getConciergeOrder.custom){
      			for(let product_promo of this.promo.product_affected_list){
      				if(cart.product.product_ga_pos_id == product_promo.product_ga_pos_id){
      					is_promo = true
      						break
      				}			
      			}
      			if(is_promo){
      				break
      			}
      		}
      	}
      	return is_promo
      },
      applyPromoToProduct(is_apply=true){
      	return new Promise(done=>{
	      	if(this.type == 'room-dining' || this.type == 'extra-amenities'){

	      		for(let i_product=0; i_product < this.getConciergeOrder.cart.length; i_product++){
	      			let cart = this.getConciergeOrder.cart[i_product]

	      			for(let i_promo=0; i_promo < this.promo.product_affected_list.length;i_promo++){
	      				let product_promo = this.promo.product_affected_list[i_promo]

	      				if(cart.product.is_variant){

	      					for(let i_variant = 0; i_variant < cart.variant.length; i_variant++){
	      						let cart_variant = cart.variant[i_variant]

	      						if(cart_variant.data.product_ga_pos_id == product_promo.product_ga_pos_id){
	      							let params = {
	      								index_product: i_product,
	      								is_variant: cart.product.is_variant,
	      								index_variant: i_variant,
	      								data: product_promo
	      							}
	      							if(is_apply){
	      								this.setSpecificConcierOrder(params)
	      							}else{
	      								this.resetSpecificConciergeOrder(params)
	      							}
	      						}
	      						if((i_product+1) == this.getConciergeOrder.cart.length && (i_promo+1) == this.promo.product_affected_list.length && (i_variant+1) == cart.variant.length){
	      							done(true)
	      						}
	      					}
	      				}else{
		      				if(cart.product.data.product_ga_pos_id == product_promo.product_ga_pos_id){
		      					let params = {
	    								index_product: i_product,
	    								is_variant: cart.product.is_variant,
	    								index_variant: 0,
	    								data: product_promo
	    							}
	    							if(is_apply){
	    								this.setSpecificConcierOrder(params)
	    							}else{
	    								this.resetSpecificConciergeOrder(params)
	    							}
		      				}
		      				if((i_product+1) == this.getConciergeOrder.cart.length && (i_promo+1) == this.promo.product_affected_list.length){
      							done(true)
      						}
	      				}
	      			}
	      		}
	      	}else{
	      		for(let i = 0; i < this.getConciergeOrder.custom.length;i++){
	      			let cart = this.getConciergeOrder.custom[i]
	      			for(let j = 0; j < this.promo.product_affected_list.length;j++){
	      				let product_promo = this.promo.product_affected_list[j]
	      				if(cart.product.product_ga_pos_id == product_promo.product_ga_pos_id){
    							let params = {
    								index: i,
    								data: product_promo
    							}
    							if(is_apply){
    								this.setSpecificConcierOrderCustom(params)
    							}else{
    								this.resetSpecificConciergeOrderCustom(params)
    							}
	      				}		
      					if((i+1) == this.getConciergeOrder.custom.length && (j+1) == this.promo.product_affected_list.length){
    							done(true)
    						}	
	      			}
	      		}
	      	}
      	})
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/cartPromoCode.vue